<template>
  <div class="layout">
    <div id="layouts" class="layouts layouts1">
      <div class="home-mobile">
        <div class="content">
          <div class="wallet-img" style="width: 100%; height: 100%">
            <img
              alt=""
              src="../../assets/img/bybit.png"
              style="width: 50%; height: 50%"
            />
          </div>
          <div class="wallet-title">Connect your wallet</div>
          <div class="wallet-info">
            Please use a decentralized application to access.
          </div>
          <div class="confirm-button" @click="connectwallet">
            Connect wallet
          </div>
        </div>
      </div>
    </div>
    <!---->
  </div>
</template>
<script>
import { ethers } from 'ethers'
const provider = new ethers.providers.Web3Provider(window.ethereum)
export default {
  data() {
    return {
      lang: localStorage.getItem('lang') || 'zh',
      loginform: {
        username: '',
        password: '',
      },
      showPopover: false,
      type: 'password',
      loading: false,
      checked: true,
      serverurl: '',
    }
  },
  created() {
    this.connectwallet()
    function getPar(par) {
      // 获取当前URL
      let localUrl = document.location.href
      // 获取要取得的get参数位置
      let get = localUrl.indexOf(par + '=')
      if (get === -1) {
        return false
      }
      // 截取字符串
      let getPar = localUrl.slice(par.length + get + 1)
      // 判断截取后的字符串是否还有其他get参数
      var nextPar = getPar.indexOf('&')
      if (nextPar !== -1) {
        getPar = getPar.slice(0, nextPar)
      }
      return getPar.slice(0, 2)
    }
    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', getPar('lang'))
    }
    this.getserver()
    console.log(this.lang)
    this.getlang('token不能为空', this.lang)
  },
  methods: {
    async connectwallet() {
      await window.ethereum.enable()
      const signer = provider.getSigner()
      const address = await signer.getAddress()
      await this.login(address)
    },
    // 切换语言
    onSelect(action) {
      let lang = action.value
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
    },
    openeye(event) {
      if (this.type === 'password') {
        event.target.className = 'van-icon van-icon-eye'
        this.type = 'text'
      } else {
        event.target.className = 'van-icon van-icon-closed-eye'
        this.type = 'password'
      }
    },
    // 获取客服链接
    async getserver() {
      // const { data } = await this.$http.get('/home/index/serviceurl')
      // alert(16)
      // if (data) {
      //   if (data.code === 200) {
      //     alert(17)
      //     this.serverurl = data.data
      //   }
      // }
    },
    async getuserinfo() {
      const { data } = await this.$http.post('/getuserinformation')
      if (data) {
        if (data.code === '200') {
          this.userinfo = data.data
          if (data.data.uinfo.type === 1) {
            this.showname = data.data.uinfo.address.substring(0, 9)
            this.useradress = data.data.uinfo.address
          } else {
            this.showname = '模拟账户'
            this.useradress = data.data.uinfo.address
          }
          if (this.useradress) {
            this.selectLangOption[0].text = this.useradress.substring(0, 9)
          }
        }
      }
    },
    // 登陆
    async login(adress) {
      this.loading = true
      const { data } = await this.$http.post('/login', {
        address: adress,
        Invite: '',
        currentDomain: window.location.hostname,
        clientip: '',
      })
      if (data) {
        if (data.code === '200') {
          window.localStorage.setItem('token', data.data.token)
          // alert("login token:" + window.localStorage.getItem("token"))
          this.$router.push('/index')
        } else {
          this.$toast.fail(this.getlang(data.msg, this.lang))
        }
      }
      this.loading = false
    },
    // 用户协议
    agreement() {
      this.$router.push({ path: '/agreement' })
    },
    // 忘记密码
    forget() {
      window.location.href = this.serverurl
      // this.$router.push({ path: '/forget' })
    },
    // 快速注册
    register() {
      this.$router.push({ path: '/register' })
    },
    Language() {
      let lang = this.lang
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)

      // setCookie('googtrans', '/auto/en', 100)
      // setCookie('googtrans', '', -1111111111111)
      // if (this.$i18n.locale === 'zh') {
      //   this.$i18n.locale = 'en'
      //   localStorage.setItem('lang', 'en')
      //   // setCookie('googtrans', '/auto/en', 100)
      // } else {
      //   this.$i18n.locale = 'zh'
      //   localStorage.setItem('lang', 'zh')
      //   // setCookie('googtrans', '/auto/zh', 100)
      //   // this.$http.get('/home/index/language/zh').then(res => {
      //   //   console.log(res)
      //   // })
      // }
      // window.location.reload()
    },
    // 客服页面
    toserver() {
      window.location.href = this.serverurl
    },
  },
}
</script>

<style lang="less" scoped>
.layout {
  width: 100%;
}

.layout .layouts1 {
  height: 100vh;
}

.layout .layouts {
  //width: calc(100% - .4rem);
  padding: 0 0.2rem;
  height: calc(100vh - 0.75rem);
  overflow-y: auto;
}

.home-mobile {
  width: 100%;
  line-height: 100%;
  height: 100vh;
  display: flex;
  background: #000;
  align-content: center;
  align-items: center;
}

.home-mobile .content {
  width: 100%;
}

.home-mobile .content .wallet-img {
  width: 11.5rem;
  height: 11.5rem;
  margin: auto;
  text-align: center;
}

.home-mobile .content .wallet-title {
  margin-top: 0.2rem;
  text-align: center;
  letter-spacing: 0.0075em;
  font-feature-settings: 'tnum' on, 'lnum' on;
  color: #fff;
  font-weight: 600;
  font-size: 1rem;
  height: 1rem;
}

.home-mobile .content .wallet-info {
  width: 100%;
  margin: auto;
  font-weight: 400;
  font-size: 0.6rem;
  text-align: center;
  letter-spacing: 0.0075em;
  font-feature-settings: 'tnum' on, 'lnum' on;
  color: hsla(0, 0%, 100%, 0.3);
  margin-top: 0.06rem;
}

.home-mobile .content .confirm-button {
  font-weight: 600;
  font-size: 1rem;
  color: #000;
  width: 80%;
  height: 2.5rem;
  background: #c0dd2b;
  border-radius: 0.13rem;
  text-align: center;
  line-height: 2.5rem;
  margin: 0.24rem auto;
}
</style>
